import cx from "classnames";

import { ReactComponent as LogoSymbol } from "./logo-symbol.svg";
import styles from "./styles.module.css";

type SpaceliftLogoProps = {
  className?: string;
  size: "xSmall" | "small" | "medium" | "large";
};

const SpaceliftLogo = ({ className, size }: SpaceliftLogoProps) => {
  return <LogoSymbol className={cx(styles.logo, className, styles[size])} />;
};

SpaceliftLogo.displayName = "DS.SpaceliftLogo";

export default SpaceliftLogo;
